import type { ReactNode } from 'react'
import styles from './Card.module.css'

interface CardProps {
  title?: string
  subtitle?: string
  /** Кнопка или отметка в правом верхнем углу. */
  action?: ReactNode
  compact?: boolean
  className?: string
  children: ReactNode
}

export function Card({ title, subtitle, action, compact, className, children }: CardProps) {
  const classes = [styles.card, compact && styles.compact, className].filter(Boolean).join(' ')

  return (
    <section className={classes}>
      {(title || action) && (
        <header className={styles.header}>
          <div className={styles.titles}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
          {action && <div className={styles.action}>{action}</div>}
        </header>
      )}
      {children}
    </section>
  )
}
